import React from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { data } from "../../../Data/data";

export default function HowItWorks2() {
   const isLg = useMediaQuery("(min-width: 767px)");
   return (
      <Style>
         <div className="bgBlack">
            <Container className="section-gap">
               <span className="red-bar text-white">THE JOURNEY</span>
               <span className="d-block font-60 font-sm-30 line-height-sm-40 line-height-73 font-syne font-weight-600 text-white mt-4">
                  Witmates Technologies A Journey of {isLg && <br />} Growth and Excellence
               </span>
               {data?.newJourneyList?.map((item) => (
                  <div className="mt-5">
                     <div className="px-4">
                        <span className="d-block font-24 witmates-theme-color font-DMSans">{item.year}</span>
                     </div>
                     <div className="hr mt-3 mb-4" />
                     <div className="px-4">
                        <span className="d-block font-24 text-uppercase font-syne mb-3">
                           <span className="text-white">{item.title.split(/#color:/)[0]}</span>
                           <span className="witmates-theme-color">{item.title.split(/#color:/)[1]}</span>
                        </span>
                        <div className="row text-white font-16 font-DMSans">
                           {item.descriptions.map((item) => (
                              <React.Fragment>
                                 <div className="col-md-4 col-12 mt-2">
                                    {item.row.map((item) => (
                                       <span className="d-block">● {item}</span>
                                    ))}
                                 </div>
                              </React.Fragment>
                           ))}
                        </div>
                     </div>
                  </div>
               ))}
            </Container>
         </div>
      </Style>
   );
}

const Style = styled.div`
   .hr {
      border: 1px solid #e6e6ea;
   }
`;
